export var checkEntrySize = function (elementRef) {
    var sizeCheckEvent = new CustomEvent('custom:size-check');
    var element = elementRef.current;
    var observer = new ResizeObserver(function () {
        document.dispatchEvent(sizeCheckEvent);
    });
    // to keep track of DOM element dimension
    observer.observe(element);
    return function () { return observer.unobserve(element); };
};
